<template>
    <div>
        <div style="padding-top:10px;">
            <h4>{{lang.common.extLogin}}</h4>
            <form method="post" class="form-horizontal" :action="extLoginUrl">
                <div>
                    <p>
                        <button type="submit" class="btn btn-primary" name="provider" value="Facebook" title="Log in using your Facebook account">Facebook</button>
                    </p>
                </div>
                <input name="provider" type="hidden" value="Facebook">
                <input name="lang" type="hidden" :value="lang.lang"/>
                <input name="__RequestVerificationToken" type="hidden" value="CfDJ8Of3s5x_YWZPkVaJgfBPYSFJMSXZB0gqC1VTdUnEf6xkOptppjsoon1B-RP9zc_s4fYKhdYEAA_5yhNi8Rxd_rLZ7lBVliJSE1L0VuATjhZ4hJMe1fryh0HSq90_mhknXJLrKZLeFNEZiMSU3GseW0k">
            </form>
        </div>                
    </div>
</template>

<script>
    export default {
        computed: {
            lang: function () {
                return this.$store.getters.lang;
            },
            hasLogin: function () {
                return this.$store.getters.account !== null;
            },
            extLoginUrl: function () {
                return this.mxnAgxApi.apiClient.getExtLoginUrl(this.currentPageUrl);
            }
        },
        data: function () {
            return {
                currentPageUrl: window.location.href
            }
        },
        watch: {
            '$route'() {
                this.currentPageUrl = window.location.href;
            }
        }
    }
</script>
